import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ItemPickerModel, ItemPickerSettingsModel } from '@shared';
import { ItemPickerTypeEnum } from '../models';

@Injectable()
export class ItemPickerFactoryService {
	public constructor(private translateService: TranslateService) {}

	public create(itemPickerType: ItemPickerTypeEnum): ItemPickerModel {
		let placeholder: string;
		let title: string;

		switch (itemPickerType) {
			case ItemPickerTypeEnum.ENVIRONMENT:
				placeholder = this.translateService.instant('importPage.transferOutOptions.database.placeholder');
				title = this.translateService.instant('importPage.transferOutOptions.database.title');
				break;
			case ItemPickerTypeEnum.BUSINESS_UNIT:
				placeholder = this.translateService.instant('importPage.transferOutOptions.businessUnit.placeholder');
				title = this.translateService.instant('importPage.transferOutOptions.businessUnit.title');
				break;
			case ItemPickerTypeEnum.DHL_LOGGING_STYLE:
				placeholder = this.translateService.instant(
					'importPage.transferOutOptions.dhlLoggingStyle.placeholder'
				);
				title = this.translateService.instant('importPage.transferOutOptions.dhlLoggingStyle.title');
				break;
			case ItemPickerTypeEnum.SSTN_LOGGING_STYLE:
				placeholder = this.translateService.instant(
					'importPage.transferOutOptions.sstnLoggingStyle.placeholder'
				);
				title = this.translateService.instant('importPage.transferOutOptions.sstnLoggingStyle.title');
				break;
			case ItemPickerTypeEnum.DESCRIPTIONS:
				placeholder = this.translateService.instant('importPage.transferOutOptions.descriptions.placeholder');
				title = this.translateService.instant('importPage.transferOutOptions.descriptions.title');
		}

		return new ItemPickerModel({
			isLoading: false,
			options: null,
			settings: {
				allowMultiSelection: false,
				title,
				placeholder
			} as ItemPickerSettingsModel
		});
	}
}
